<template>
  <div>
    <b-form @submit="savePool">
      <div>
        <b-tabs vertical pills card content-class="mt-3">
          <b-tab :title="$t('Main parameters')" active>
            <b-form-group label-align="right" label='ID' label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isEdit">
                <b-form-input type="text" disabled v-model="currentRowPool.id"/>
            </b-form-group>

            <b-form-group label-align="right" :label="$t('Gateway')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input required type="text" v-model="pool.gateway"/>
            </b-form-group>

            <b-form-group label-align="right" :label="$t('Mask')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="text" v-model="pool.netmask" placeholder="255.255.255.0" required/>
            </b-form-group>

            <b-form-group label-align="right" :label="$t('DNS server 1')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input required type="text" v-model="pool.dns1_server"/>
            </b-form-group>

            <b-form-group label-align="right" :label="$t('DNS server 2')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="text" v-model="pool.dns2_server"/>
            </b-form-group>

            <b-form-group label-align="right" :label="$t('NTP server')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="text" v-model="pool.ntp_server"/>
            </b-form-group>

            <b-form-group label-align="right" :label="$t('Domain')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="text" v-model="pool.domain_name"/>
            </b-form-group>

            <b-form-group label-align="right" :label="$t('Lease time')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="text" v-model="pool.lease_time"/>
            </b-form-group>

            <b-form-group label-align="right" :label="$t('Block action')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-select :options="blockActionSelect" v-model="pool.block_action_type"></b-form-select>
            </b-form-group>

            <b-form-group label-align="right" style="margin-top:-1rem" :label="$t('Pool ID')" v-if="pool.block_action_type === 2" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-select :options="DhcpPoolsOpts" v-model="pool.block_pool_id"></b-form-select>
            </b-form-group>
          </b-tab>

          <b-tab :title="$t('Dynamic ranges')" >
            <md-button class="md-raised" @click="showmodalRange" >{{ $t('Add') }}</md-button>
            <b-table striped hover small
                      :items="dhcpRangesItems"
                      :fields="dhcpRangesFields">
              <template v-slot:cell(actions)="row">
                <i @click.stop="ClickOnDeletePoolButton(row)" class="danger fa fa-trash-alt fa-lg" />
              </template>
            </b-table>

            <b-modal hide-footer ref="modalRanges"  :title="$t('Range')">
              <b-form-group label-align="right" :label="$t('First address')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-input type="text" v-model="newRange.first_addr"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Last address')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-input type="text" v-model="newRange.last_addr"/>
              </b-form-group>
              <modal-ok-cancel @save="rangeSubmit" @cancel="hidemodalRange" size="md"/>
            </b-modal>
          </b-tab>

          <b-modal hide-footer ref="MOption125"  :title="$t('Option 125 (Vendor-Specific Information)')">
            <option125 ref="Option125"/>
            <modal-ok-cancel @save="getOption125" @cancel="$refs.MOption125.hide()" size="md"/>
          </b-modal>

          <b-tab :title="$t('DHCP options')">
            <div>
              <b-form>
                <md-button class="md-raised" @click="showmodalOption" >{{ $t('Add Option') }}</md-button>
                <md-button class="md-raised" @click="$refs.MOption125.show()" >{{ $t('Add Option 125') }}</md-button>
                <b-table striped hover small
                    :items="dhcpOptionsList"
                    :fields="dhcpOptionsFields">
                    <template v-slot:cell(actions)="row">
                      <i @click.stop="ClickOnDeleteOptsButton(row)" class="danger fa fa-trash-alt fa-lg" />
                    </template>
                    <template v-slot:cell(flag)="row">
                        <b-form-checkbox disabled switch size="sm" v-model="row.item.flag"/>
                    </template>
                </b-table>
                </b-form>
                <b-modal hide-footer ref="modalOption"  :title="$t('Option')">
                  <b-form-group label-align="right" :label="$t('Option ID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                      <b-form-input @change="optTypeUpd" type="text" v-model="newOpt.option_id"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                      <b-form-select  :options="dhcpOptsTypes" type="text" v-model="newOpt.type"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Value')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                      <b-form-input type="text" v-model="newOpt.value"/>
                  </b-form-group>
                  <b-form-group style="margin-top:-2%" label-align="right" :label="$t('Force Add')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-checkbox switch v-model="newOpt.flag"></b-checkbox>
                  </b-form-group>
                  <modal-ok-cancel @save="optSubmit" @cancel="hidemodalOption" size="md"/>
                </b-modal>
            </div>
          </b-tab>
        </b-tabs>
      </div>

      <modal-ok-cancel @save="savePool" @cancel="hideAddPool" size="lg"/>
    </b-form>

  </div>
</template>

<script>
import option125 from '@/components/option125.vue'
export default {
  components: {
    option125
  },
  props: {
    isEdit: null,
    currentRowPool: null
  },
  data () {
    return {
      deleteImage: require('@/assets/img/document_delete.png'),
      isOptsModifiedFlag: false,
      blockActionSelect: [
        { value: 1, text: this.$i18n.t('Not defined') },
        { value: 2, text: this.$i18n.t('Use blocked') },
        { value: 3, text: this.$i18n.t('Ignore request') }
      ],
      pool: {
        'block_action_type': '',
        'block_pool_id': '',
        'dns1_server': '',
        'dns2_server': '',
        'domain_name': '',
        'gateway': '',
        'id': '',
        'lease_time': '',
        'netmask': '255.255.255.0',
        'flags': 1,
        'ntp_server': '',
        'ranges': [
          {
            'first_addr': '',
            'last_addr': ''
          }
        ]
      },
      newOpt: {
        'option_id': '',
        'type': '',
        'value': '',
        'flag': false
      },
      emptyOpt: {
        'option_id': '',
        'type': '',
        'value': '',
        'flag': false
      },
      newRange: {
        'first_addr': '',
        'last_addr': ''
      },
      emptyRange: {
        'first_addr': '',
        'last_addr': ''
      },
      dhcpRangesItems: [],
      dhcpRangesFields: [
        {key: 'first_addr', label: this.$i18n.t('First address'), sortable: true},
        {key: 'last_addr', label: this.$i18n.t('Last address'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      dhcpOptionsList: [],
      optFlagForceAdd: 1,
      dhcpOptionsFields: [
        {key: 'option_id', label: this.$i18n.t('Option ID'), sortable: true},
        {key: 'type', label: this.$i18n.t('Type'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'flag', label: this.$i18n.t('Force Add'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      dhcpOptionPut: {
        'owner_id': '',
        'type': 2,
        'options': [
        ]
      },
      availibleIpSymbols: '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$',
      maskMap: new Map(
        [
          ['255.255.255.255', 32],
          ['255.255.255.254', 31],
          ['255.255.255.252', 30],
          ['255.255.255.248', 29],
          ['255.255.255.240', 28],
          ['255.255.255.224', 27],
          ['255.255.255.192', 26],
          ['255.255.255.128', 25],
          ['255.255.255.0', 24],
          ['255.255.254.0', 23],
          ['255.255.252.0', 22],
          ['255.255.248.0', 21],
          ['255.255.240.0', 20],
          ['255.255.224.0', 19],
          ['255.255.192.0', 18],
          ['255.255.128.0', 17],
          ['255.255.0.0', 16],
          ['255.254.0.0', 15],
          ['255.252.0.0', 14],
          ['255.248.0.0', 13],
          ['255.240.0.0', 12],
          ['255.224.0.0', 11],
          ['255.192.0.0', 10],
          ['255.128.0.0', 9],
          ['255.0.0.0', 8],
          ['254.0.0.0', 7],
          ['252.0.0.0', 6],
          ['248.0.0.0', 5],
          ['240.0.0.0', 4],
          ['224.0.0.0', 3],
          ['192.0.0.0', 2],
          ['128.0.0.0', 1],
          ['0.0.0.0', 0]
        ]),
      dhcpOptsTypeMap: new Map([
        [1, this.$i18n.t('Number')],
        [2, this.$i18n.t('String')],
        [3, this.$i18n.t('IP address')],
        [4, this.$i18n.t('Binary')],
        [5, this.$i18n.t('IP address array')],
        [6, this.$i18n.t('Number(16)')]
      ]),
      dhcpOptsTypeReverseMap: new Map([
        [this.$i18n.t('Number'), 1],
        [this.$i18n.t('String'), 2],
        [this.$i18n.t('IP address'), 3],
        [this.$i18n.t('Binary'), 4],
        [this.$i18n.t('IP address array'), 5],
        [this.$i18n.t('Number(16)'), 6]
      ]),
      dhcpOptsTypes: [this.$i18n.t('Number'), this.$i18n.t('String'),
        this.$i18n.t('IP address'), this.$i18n.t('Binary'), this.$i18n.t('IP address array')],
      dhcpOptsKnownId: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
        38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54,
        55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71,
        72, 73, 74, 75, 76, 77, 81, 82, 85, 86, 87, 118, 121, 122, 128, 185, 220, 221, 251],
      dhcpOptsIdMap: new Map([
        [1, ['1 (subnet-mask (derived))', 3]],
        [2, ['2 (time-offset)', 1]],
        [3, ['3 (routers)', 5]],
        [4, ['4 (time-servers)', 5]],
        [5, ['5 (name-servers)', 5]],
        [6, ['6 (domain-name-servers)', 5]],
        [7, ['7 (log-servers)', 5]],
        [8, ['8 (cookie-servers)', 5]],
        [9, ['9 (lpr-servers)', 5]],
        [10, ['10 (impress-servers)', 5]],
        [11, ['11 (resource-location-servers)', 5]],
        [12, ['12 (host-name)', 2]],
        [13, ['13 (boot-size)', 4]],
        [14, ['14 (merit-dump)', 2]],
        [15, ['15 (domain-name)', 2]],
        [16, ['16 (swap-server)', 3]],
        [17, ['17 (root-path)', 2]],
        [18, ['18 (extensions-path)', 2]],
        [19, ['19 (ip-forwarding)', 1]],
        [20, ['20 (non-local-source-routing)', 1]],
        [21, ['21 (policy-filters)', 5]],
        [22, ['22 (max-dgram-reassembly)', 4]],
        [23, ['23 (default-ip-ttl)', 4]],
        [24, ['24 (path-mtu-aging-timeout)', 1]],
        [25, ['25 (path-mtu-plateau-tables)', 4]],
        [26, ['26 (interface-mtu)', 4]],
        [27, ['27 (all-subnets-local)', 1]],
        [28, ['28 (broadcast-address)', 3]],
        [29, ['29 (perform-mask-discovery)', 1]],
        [30, ['30 (mask-supplier)', 1]],
        [31, ['31 (router-discovery)', 1]],
        [32, ['32 (router-solicitation-address)', 3]],
        [33, ['33 (static-routes)', 5]],
        [34, ['34 (trailer-encapsulation)', 1]],
        [35, ['35 (arp-cache-timeout)', 1]],
        [36, ['36 (ieee802.3-encapsulation)', 1]],
        [37, ['37 (default-tcp-ttl)', 4]],
        [38, ['38 (tcp-keepalive-interval)', 1]],
        [39, ['39 (tcp-keepalive-garbage)', 1]],
        [40, ['40 (nis-domain)', 2]],
        [41, ['41 (nis-servers)', 5]],
        [42, ['42 (ntp-servers)', 5]],
        [43, ['43 (vendor-encapsulated-options)', 4]],
        [44, ['44 (netbios-name-servers)', 5]],
        [45, ['45 (netbios-dd-servers)', 5]],
        [46, ['46 (netbios-node-type)', 4]],
        [47, ['47 (netbios-scope)', 2]],
        [48, ['48 (font-servers)', 5]],
        [49, ['49 (x-display-managers)', 5]],
        [50, ['50 (dhcp-requested-address (set by DHCP client))', 3]],
        [51, ['51 (dhcp-lease-time)', 1]],
        [52, ['52 (dhcp-option-overload)', 4]],
        [53, ['53 (dhcp-message-type (set by protocols))', 4]],
        [54, ['54 (dhcp-server-identifier (set by DHCP server))', 3]],
        [55, ['55 (dhcp-parameter-request-list)', 4]],
        [56, ['56 (dhcp-message)', 2]],
        [57, ['57 (dhcp-max-message-size (set by protocol))', 4]],
        [58, ['58 (dhcp-renewal-time)', 1]],
        [59, ['59 (dhcp-rebinding-time)', 1]],
        [60, ['60 (dhcp-class-identifier (set by DHCP client))', 2]],
        [61, ['61 (dhcp-client-identifier (set by DHCP client))', 4]],
        [62, ['62 (netwareip-domain)', 2]],
        [63, ['63 (netwareip-information)', 4]],
        [64, ['64 (nis+-domain)', 2]],
        [65, ['65 (nis+-servers)', 5]],
        [66, ['66 (tftp-server)', 2]],
        [67, ['67 (boot-file)', 2]],
        [68, ['68 (mobile-ip-home-agents)', 5]],
        [69, ['69 (smtp-servers)', 5]],
        [70, ['70 (pop3-servers)', 5]],
        [71, ['71 (nntp-servers)', 5]],
        [72, ['72 (www-servers)', 5]],
        [73, ['73 (finger-servers)', 5]],
        [74, ['74 (irc-servers)', 5]],
        [75, ['75 (streettalk-servers)', 5]],
        [76, ['76 (streettalk-directory-assistance-servers)', 5]],
        [77, ['77 (dhcp-user-class-id (set by DHCP client))', 2]],
        [81, ['81 (client-fqdn)', 4]],
        [82, ['82 (relay-agent-info)', 4]],
        [85, ['85 (nds-servers)', 5]],
        [86, ['86 (nds-tree)', 2]],
        [87, ['87 (nds-context)', 2]],
        [118, ['118 (subnet-selection)', 3]],
        [121, ['121 (classless-route)', 3]],
        [122, ['122 (cablelabs-client-configuration)', 4]],
        [128, ['128 (mcns-security-server)', 3]],
        [185, ['185 (vpn-id)', 4]],
        [220, ['220 (cisco-subnet-allocation)', 4]],
        [221, ['221 (cisco-vpn-id)', 4]],
        [251, ['251 (auto-configure)', 4]]
      ]),
      dhcpOptsIdReverseMap: new Map([
        ['1 (subnet-mask (derived))', 1],
        ['2 (time-offset)', 2],
        ['3 (routers)', 3],
        ['4 (time-servers)', 4],
        ['5 (name-servers)', 5],
        ['6 (domain-name-servers)', 6],
        ['7 (log-servers)', 7],
        ['8 (cookie-servers)', 8],
        ['9 (lpr-servers)', 9],
        ['10 (impress-servers)', 10],
        ['11 (resource-location-servers)', 11],
        ['12 (host-name)', 12],
        ['13 (boot-size)', 13],
        ['14 (merit-dump)', 14],
        ['15 (domain-name)', 15],
        ['16 (swap-server)', 16],
        ['17 (root-path)', 17],
        ['18 (extensions-path)', 18],
        ['19 (ip-forwarding)', 19],
        ['20 (non-local-source-routing)', 20],
        ['21 (policy-filters)', 21],
        ['22 (max-dgram-reassembly)', 22],
        ['23 (default-ip-ttl)', 23],
        ['24 (path-mtu-aging-timeout)', 24],
        ['25 (path-mtu-plateau-tables)', 25],
        ['26 (interface-mtu)', 26],
        ['27 (all-subnets-local)', 27],
        ['28 (broadcast-address)', 28],
        ['29 (perform-mask-discovery)', 29],
        ['30 (mask-supplier)', 30],
        ['31 (router-discovery)', 31],
        ['32 (router-solicitation-address)', 32],
        ['33 (static-routes)', 33],
        ['34 (trailer-encapsulation)', 34],
        ['35 (arp-cache-timeout)', 35],
        ['36 (ieee802.3-encapsulation)', 36],
        ['37 (default-tcp-ttl)', 37],
        ['38 (tcp-keepalive-interval)', 38],
        ['39 (tcp-keepalive-garbage)', 39],
        ['40 (nis-domain)', 40],
        ['41 (nis-servers)', 41],
        ['42 (ntp-servers)', 42],
        ['43 (vendor-encapsulated-options)', 43],
        ['44 (netbios-name-servers)', 44],
        ['45 (netbios-dd-servers)', 45],
        ['46 (netbios-node-type)', 46],
        ['47 (netbios-scope)', 47],
        ['48 (font-servers)', 48],
        ['49 (x-display-managers)', 49],
        ['50 (dhcp-requested-address (set by DHCP client))', 50],
        ['51 (dhcp-lease-time)', 51],
        ['52 (dhcp-option-overload)', 52],
        ['53 (dhcp-message-type (set by protocols))', 53],
        ['54 (dhcp-server-identifier (set by DHCP server))', 54],
        ['55 (dhcp-parameter-request-list)', 55],
        ['56 (dhcp-message)', 56],
        ['57 (dhcp-max-message-size (set by protocol))', 57],
        ['58 (dhcp-renewal-time)', 58],
        ['59 (dhcp-rebinding-time)', 59],
        ['60 (dhcp-class-identifier (set by DHCP client))', 60],
        ['61 (dhcp-client-identifier (set by DHCP client))', 61],
        ['62 (netwareip-domain)', 62],
        ['63 (netwareip-information)', 63],
        ['64 (nis+-domain)', 64],
        ['65 (nis+-servers)', 65],
        ['66 (tftp-server)', 66],
        ['67 (boot-file)', 67],
        ['68 (mobile-ip-home-agents)', 68],
        ['69 (smtp-servers)', 69],
        ['70 (pop3-servers)', 70],
        ['71 (nntp-servers)', 71],
        ['72 (www-servers)', 72],
        ['73 (finger-servers)', 73],
        ['74 (irc-servers)', 74],
        ['75 (streettalk-servers)', 75],
        ['76 (streettalk-directory-assistance-servers)', 76],
        ['77 (dhcp-user-class-id (set by DHCP client))', 77],
        ['81 (client-fqdn)', 81],
        ['82 (relay-agent-info)', 82],
        ['85 (nds-servers)', 85],
        ['86 (nds-tree)', 86],
        ['87 (nds-context)', 87],
        ['118 (subnet-selection)', 118],
        ['121 (classless-route)', 121],
        ['122 (cablelabs-client-configuration)', 122],
        ['128 (mcns-security-server)', 128],
        ['185 (vpn-id)', 185],
        ['220 (cisco-subnet-allocation)', 220],
        ['221 (cisco-vpn-id)', 221],
        ['251 (auto-configure)', 251]
      ]),
      dhcpOptsKnownIdname: ['1 (subnet-mask (derived))', '2 (time-offset)', '3 (routers)', '4 (time-servers)',
        '5 (name-servers)', '6 (domain-name-servers)', '7 (log-servers)', '8 (cookie-servers)', '9 (lpr-servers)',
        '10 (impress-servers)', '11 (resource-location-servers)', '12 (host-name)', '13 (boot-size)', '14 (merit-dump)',
        '15 (domain-name)', '16 (swap-server)', '17 (root-path)', '18 (extensions-path)', '19 (ip-forwarding)',
        '20 (non-local-source-routing)', '21 (policy-filters)', '22 (max-dgram-reassembly)', '23 (default-ip-ttl)',
        '24 (path-mtu-aging-timeout)', '25 (path-mtu-plateau-tables)', '26 (interface-mtu)', '27 (all-subnets-local)',
        '28 (broadcast-address)', '29 (perform-mask-discovery)', '30 (mask-supplier)', '31 (router-discovery)',
        '32 (router-solicitation-address)', '33 (static-routes)', '34 (trailer-encapsulation)', '35 (arp-cache-timeout)',
        '36 (ieee802.3-encapsulation)', '37 (default-tcp-ttl)', '38 (tcp-keepalive-interval)', '39 (tcp-keepalive-garbage)',
        '40 (nis-domain)', '41 (nis-servers)', '42 (ntp-servers)', '43 (vendor-encapsulated-options)', '44 (netbios-name-servers)',
        '45 (netbios-dd-servers)', '46 (netbios-node-type)', '47 (netbios-scope)', '48 (font-servers)', '49 (x-display-managers)',
        '50 (dhcp-requested-address (set by DHCP client))', '51 (dhcp-lease-time)', '52 (dhcp-option-overload)',
        '53 (dhcp-message-type (set by protocols))', '54 (dhcp-server-identifier (set by DHCP server))', '55 (dhcp-parameter-request-list)',
        '56 (dhcp-message)', '57 (dhcp-max-message-size (set by protocol))', '58 (dhcp-renewal-time)', '59 (dhcp-rebinding-time)',
        '60 (dhcp-class-identifier (set by DHCP client))', '61 (dhcp-client-identifier (set by DHCP client))', '62 (netwareip-domain)',
        '63 (netwareip-information)', '64 (nis+-domain)', '65 (nis+-servers)', '66 (tftp-server)', '67 (boot-file)',
        '68 (mobile-ip-home-agents)', '69 (smtp-servers)', '70 (pop3-servers)', '71 (nntp-servers)', '72 (www-servers)',
        '73 (finger-servers)', '74 (irc-servers)', '75 (streettalk-servers)', '76 (streettalk-directory-assistance-servers)',
        '77 (dhcp-user-class-id (set by DHCP client))', '81 (client-fqdn)', '82 (relay-agent-info)', '85 (nds-servers)',
        '86 (nds-tree)', '87 (nds-context)', '118 (subnet-selection)', '121 (classless-route)', '122 (cablelabs-client-configuration)',
        '128 (mcns-security-server)', '185 (vpn-id)', '220 (cisco-subnet-allocation)', '221 (cisco-vpn-id)', '251 (auto-configure)'],
      opts125: []
    }
  },
  methods: {
    addHexZeroPad (hex) {
      let res = hex
      if (hex.length % 2 === 1) {
        res = '0' + hex
      }
      return res
    },
    getOption125 () {
      let opt125 = this.$refs.Option125.getOption()
      let opt125Val = 'Enterprise: ' + opt125.Enterprise + '\n'
      const hexEnterpriseID = Number(opt125.Enterprise).toString(16).padStart(8, '0')
      let hexValue = hexEnterpriseID
      let subOptsLen = 0
      let subOptsHex = ''
      for (let subOpt of opt125.SubOpts) {
      // Len valueLen + 2 (supOptID + subOptLen)
        // Subopt ID
        subOptsHex = subOptsHex + this.addHexZeroPad(subOpt.ID.toString(16))
        opt125Val = opt125Val + 'SuboptID: ' + subOpt.ID + '\n'

        // // Hex value
        switch (subOpt.Type) {
          case this.$i18n.t('Number(32)'):
            subOptsLen = subOptsLen + 4 + 2
            let hexNum = Number(subOpt.Data).toString(16)
            // Hex value len Number integer(4 byte = 8 hexDigit)
            subOptsHex = subOptsHex + (Number(4)).toString(16).padStart(2, '0')
            subOptsHex = subOptsHex + hexNum.padStart(8, '0')
            break
          case this.$i18n.t('String'):
            subOptsLen = subOptsLen + Number(subOpt.Data.length) + 2
            // Hex value len
            subOptsHex = subOptsHex + subOpt.Data.length.toString(16).padStart(2, '0')
            subOptsHex = subOptsHex + Buffer.from(String(subOpt.Data)).toString('hex')
            break
          case this.$i18n.t('IP address'):
            subOptsLen = subOptsLen + 4 + 2
            let ipHex = ''
            subOpt.Data.split('.').forEach(byte => { ipHex = ipHex + Number(byte).toString(16).padStart(2, '0') })
            subOptsHex = subOptsHex + (Number(4)).toString(16).padStart(2, '0')
            subOptsHex = subOptsHex + ipHex
            break
          case this.$i18n.t('Binary'):
            subOptsLen = subOptsLen + Number(subOpt.Data.length / 2) + 2
            // Hex value len 2hex = 1 byte
            subOptsHex = subOptsHex + (subOpt.Data.length / 2).toString(16).padStart(2, '0')
            subOptsHex = subOptsHex + subOpt.Data
            break
          case this.$i18n.t('Number(16)'):
            subOptsLen = subOptsLen + 2 + 2
            let hexNum16 = Number(subOpt.Data).toString(16)
            // Hex value len 2hex = 1 byte , 2 Byte
            subOptsHex = subOptsHex + (Number(2)).toString(16).padStart(2, '0')
            subOptsHex = subOptsHex + hexNum16.padStart(4, '0')
            break
        }
        opt125Val = opt125Val + 'Subopt value: ' + subOpt.Data + '\n'
      }
      // sub opts len
      hexValue = hexValue + subOptsLen.toString(16).padStart(2, '0')
      // sub opts binary value
      hexValue = hexValue + subOptsHex
      let tmpOpt = JSON.parse(JSON.stringify(this.emptyOpt))
      tmpOpt.type = this.$i18n.t('Binary')
      tmpOpt.option_id = 125
      tmpOpt.value = hexValue
      tmpOpt.flag = opt125.Flag
      this.dhcpOptionsList.push({option_id: 125, value: opt125Val, type: this.$i18n.t('Binary'), flag: opt125.Flag})
      this.opts125.push(tmpOpt)
      this.isOptsModifiedFlag = true
      this.$refs.MOption125.hide()
    },
    optTypeUpd () {
      if (this.dhcpOptsKnownId.includes(Number(this.newOpt.option_id))) {
        this.newOpt.type = this.dhcpOptsTypeMap.get(this.dhcpOptsIdMap.get(Number(this.newOpt.option_id))[1])
        this.newOpt.option_id = this.dhcpOptsIdMap.get(Number(this.newOpt.option_id))[0]
      }
    },
    ClickOnDeleteOptsButton (row) {
      this.selectSubnet = row.item
      this.dhcpOptionsList = this.dhcpOptionsList.filter((value) => {
        return (value.option_id + value.value) !== (this.selectSubnet.option_id + this.selectSubnet.value)
      })
      this.opts125 = this.opts125.filter((value) => {
        return value.prepared_val !== this.selectSubnet.value
      })
      this.isOptsModifiedFlag = true
    },
    hideAddPool () {
      this.$emit('hideAddPool')
    },
    hidemodalOption () {
      this.$refs.modalOption.hide()
    },
    hidemodalRange () {
      this.$refs.modalRanges.hide()
    },
    showmodalOption () {
      this.$refs.modalOption.show()
    },
    showmodalRange () {
      this.$refs.modalRanges.show()
    },
    rangeSubmit () {
      this.dhcpRangesItems.push(this.newRange)
      this.newRange = JSON.parse(JSON.stringify(this.emptyOpt))
      this.hidemodalRange()
    },
    optSubmit () {
      let tmpOpt = JSON.parse(JSON.stringify(this.newOpt))
      this.dhcpOptionsList.push(tmpOpt)
      this.newOpt = JSON.parse(JSON.stringify(this.emptyOpt))
      this.isOptsModifiedFlag = true
      this.hidemodalOption()
    },
    ClickOnDeletePoolButton (row) {
      this.dhcpRangesItems = this.dhcpRangesItems.filter(function (value) {
        return value !== row.item
      })
    },
    load () {
      if (this.currentRowPool && this.isEdit) {
        this.getDHCPOptions()
        if (this.currentRowPool.dns2_server === '0.0.0.0') { this.currentRowPool.dns2_server = '' }
        if (this.currentRowPool.ntp_server === '0.0.0.0') { this.currentRowPool.ntp_server = '' }
        this.pool = this.currentRowPool
        this.dhcpRangesItems = this.currentRowPool.ranges
      }
    },
    deletePoolOpts () {
      let payload = {
        type: 2,
        id: 0
      }
      payload.id = this.currentRowPool.id
      let response = this.$store.dispatch('Inventory/DELETE_DHCP_OPTIONS', payload)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$root.$emit('makeToasts', 'success', this.$i18n.t('Pools linked to switch'))
        }
      })
    },
    async getDHCPOptions () {
      let payload = {
        type: 2,
        id: 0
      }
      payload.id = this.currentRowPool.id
      await this.$store.dispatch('Inventory/GET_DHCP_OPTIONS', payload).then(response => {
        let tmpArr = JSON.parse(JSON.stringify(this.$store.getters['Inventory/DHCP_OPTIONS']))
        tmpArr.forEach(element => {
          if (this.dhcpOptsKnownId.includes(element.option_id)) {
            this.dhcpOptionsList.push(
              {
                option_id: this.dhcpOptsIdMap.get(element.option_id)[0],
                type: this.dhcpOptsTypeMap.get(element.data_type),
                value: element.data,
                flag: element.flag === 1
              }
            )
          } else {
            if (element.option_id !== 125) {
              this.dhcpOptionsList.push(
                {
                  option_id: element.option_id,
                  type: this.dhcpOptsTypeMap.get(element.data_type),
                  value: element.data,
                  flag: element.flag === 1
                })
            } else {
              this.dhcpOptionsList.push(
                {
                  option_id: element.option_id,
                  type: this.dhcpOptsTypeMap.get(element.data_type),
                  value: this.parseOpt125Value(element.data, element.flag),
                  flag: element.flag === 1
                })
            }
          }
        })
      })
    },
    subOpt125Parser (val) {
      let res = '\n SubOptID: ' + parseInt(val.slice(0, 2), 16)
      res = res + ' SubOptLength: ' + parseInt(val.slice(2, 4), 16)
      res = res + ' SubOptString: ' + this.hex_to_ascii(val.slice(4)) + ' (hex:' + val.slice(4) + ')'
      return res
    },
    hex_to_ascii (str1) {
      var hex = str1.toString()
      var str = ''
      for (var n = 0; n < hex.length; n += 2) {
        str += String.fromCharCode(parseInt(hex.substr(n, 2), 16))
      }
      return str
    },
    parseOpt125Value (val, flag_) {
      let res = 'Enterprise : '
      let EnterpriseID = val.slice(0, 8)
      res = res + parseInt(EnterpriseID, 16)
      let l = val.slice(8, 10)
      if (l === 0) {
        this.opts125.push({option_id: 125, type: 4, value: val, flag: flag_, prepared_val: res})
        return res
      }
      res = res + ' Length: ' + parseInt(l, 16)
      let currentIndx = 0
      let subOpts = val.slice(10)
      while (subOpts.length > 0) {
        let lenStr = subOpts.slice(2, 4)
        let SOptLen = parseInt(lenStr, 16)
        if (isNaN(SOptLen) || lenStr === '00') {
          break
        }
        let dataLen = 2 * Number(SOptLen)
        let idAndL = 2 + 2 // id = 1 byte(2 character)  Length = 1 byte
        currentIndx = dataLen + idAndL
        res = res + this.subOpt125Parser(subOpts.slice(0, currentIndx))
        subOpts = subOpts.slice(currentIndx)
      }
      this.opts125.push({option_id: 125, type: 4, value: val, flag: flag_, prepared_val: res})
      return res
    },
    setSwitchOpts (addedSwID) {
      this.dhcpOptionPut.owner_id = Number(addedSwID)
      for (let element of this.dhcpOptionsList) {
        if (this.dhcpOptsKnownIdname.includes(element.option_id)) {
          let tmpOpt = element.option_id
          element.option_id = this.dhcpOptsIdReverseMap.get(tmpOpt)
        } else { element.option_id = Number(element.option_id) }
        let tmpType = element.type
        element.type = this.dhcpOptsTypeReverseMap.get(tmpType)
        let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
        if (element.type === 1) {
          element.value = Number(element.value)
        } else if (element.type === 2) {
          element.value = String(element.value)
        } else if (element.type === 3) {
          element.value = String(element.value)
          if (element.value.match(goodChars)) { continue } else {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Ip address has failed format'), 'Error')
          }
        } else if (element.type === 4) {
          element.value = String(element.value)
        } else if (element.type === 5) {
          element.value = String(element.value).split(/[,;]/)
          for (let ip of element.value) {
            if (ip.match(goodChars)) { continue } else {
              this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Ip address has failed format'), 'Error')
            }
          }
        }
      }
      let hasOpt125 = false
      this.dhcpOptionsList.forEach(element => {
        if (element.option_id === 125) {
          hasOpt125 = true
        } else {
          this.dhcpOptionPut.options.push(
            {id: element.option_id,
              data_type: element.type,
              data_value: element.value,
              flag: element.flag ? 1 : 0 })
        }
      })
      if (hasOpt125) {
        this.opts125.forEach(el => {
          this.dhcpOptionPut.options.push(
            {id: 125,
              data_type: 4,
              data_value: el.value,
              flag: el.flag ? 1 : 0 })
        })
      }

      let response = this.$store.dispatch('Inventory/CREATE_DHCP_OPTIONS', this.dhcpOptionPut)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$root.$emit('makeToasts', 'success', this.$i18n.t('Options added to switch'))
        }
      })
    },
    verifyIP (arr) {
      let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
      for (let element of arr) {
        if (element.match(goodChars)) { continue } else {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Ip address has failed format'), 'Error')
          return false
        }
      }
      return true
    },
    savePool () {
      if (!this.verifyIP([this.pool.gateway, this.pool.dns1_server, this.pool.netmask])) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Ip address of gateway, mask or dns1  has failed format'), 'Error')
        return
      }
      if (this.pool.dns2_server) {
        if (!this.verifyIP([this.pool.dns2_server])) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Ip address of dns server 2 has failed format'), 'Error')
          return
        }
      }
      if (this.pool.ntp_server) {
        if (!this.verifyIP([this.pool.ntp_server])) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Ip address of ntp server has failed format'), 'Error')
          return
        }
      }
      this.pool.ranges = this.dhcpRangesItems
      for (let range of this.pool.ranges) {
        if (range.first_addr) {
          if (!this.verifyIP([range.first_addr])) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Ip address of ranges last address has failed format'), 'Error')
            return
          }
        }
        if (range.last_addr) {
          if (!this.verifyIP([range.last_addr])) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Ip address of ranges last address has failed format'), 'Error')
            return
          }
        }
      }
      if (!this.maskMap.has(this.pool.netmask)) { return }
      if (this.pool.block_action_type) { this.pool.flags = Number(this.pool.block_action_type) }
      this.pool.pool_id = Number(this.pool.id)
      this.pool.block_pool_id = Number(this.pool.block_pool_id)
      this.pool.mask = this.maskMap.get(this.pool.netmask)
      this.pool.domain = this.pool.domain_name
      this.pool.lease_time = Number(this.pool.lease_time)
      if (this.isEdit) {
        this.$store.dispatch('Inventory/UPDATE_DHCP_POOLS', this.pool).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$root.$emit('makeToasts', 'success', this.$i18n.t('Pool updated'))
            if (this.isOptsModifiedFlag) {
              this.deletePoolOpts()
              this.setSwitchOpts(this.currentRowPool.id)
            }
            setTimeout(this.$store.dispatch, 500, 'Inventory/GET_DHCP_POOLS')
            this.hideAddPool()
          }
        })
      } else {
        this.$store.dispatch('Inventory/CREATE_DHCP_POOLS', this.pool).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            if (this.isOptsModifiedFlag) { this.setSwitchOpts(response.data.pool_id) }
            this.$root.$emit('makeToasts')
            setTimeout(this.$store.dispatch, 500, 'Inventory/GET_DHCP_POOLS')
            this.hideAddPool()
          }
        })
      }
    }
  },
  computed: {
    DhcpPoolsOpts () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Inventory/DHCP_POOLS']))
      let ret = []
      copy.forEach(el => { ret.push({ value: el.id, text: '(' + el.id + ') ' + el.gateway + '/' + el.netmask }) })
      return ret
    }
  },
  mounted () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/network/dhcpPools/formAdd.vue